import {createAsyncThunk} from '@reduxjs/toolkit';
import {type Notification} from '../notification/reducer';
import ApiUtils from 'api/ApiUtils';

export const fetchNotifications = createAsyncThunk<
  {notification: Notification[]; count: number},
  // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
  void
>('notifications/fetchNotifications', async () => {
  try {
    const response: any = await ApiUtils.getNotificationlList();
    return {
      notification: response?.data?.notification ?? [], // Ensure an array
      count: response?.data?.notificationCount ?? 0, // Ensure a number
    };
  } catch (error: any) {
    throw new Error('Failed to fetch notifications');
  }
});
